var VrBrochureView = function(params){
    /*"use strict";*/
    var _this = this,
        _jsonData = {},
        _pagesWrapSel = '.vr-mobile-body',
        _jsLoadMorePagesSel = '.js-vr-load-more-pages',
        _jsLastPageBtnSel = '.js-vr-last-page-btn',
        _pageWrapClass = 'vr-mobile-body__page-img-wrap',
        _imgBlazyClass = 'b-lazy',
        _thumbsKey = "thumbImage",
        _qualityKey = 'mediumImage',
        _preloadImagesCount = 3,
        _imgsPerPageCnt = isMobile === false ? 40 : 10,
        _imgWrapMarginH = (typeof isTablet !== 'undefined' && isTablet === true ? 120 : 0),
        _initialPagesLoaded = false,
        _relatedBrochureLoaded = false,
        vrPinZones;
    
    function _translateObjects(items) {
        if (typeof items !== 'undefined' && items !== null && items.images && items.images.length) {
            var newItems = Array(items.images.length),
                images = items.images;


            for (var i = 0, len = images.length; i < len; i++) {
                newItems[i] = {};

                if(typeof images.thumbs[( i == 24 ? 25 : i)] !== 'undefined'){
                    newItems[i].thumbImage = {
                        src: images.thumbs[i].src,
                        w: parseInt(images.thumbs[i].width),
                        h: parseInt(images.thumbs[i].height),
                        pid: parseInt(i),
                    };
                }else{
                    newItems[i].thumbImage = { src: "", w: 0, h: 0, pid: 0 };
                }

                if(typeof images.medium[i] !== 'undefined'){
                    newItems[i].mediumImage = {
                        src: images.medium[i].src,
                        w: parseInt(images.medium[i].width),
                        h: parseInt(images.medium[i].height),
                        pid: parseInt(i),
                    };
                }else{
                    newItems[i].mediumImage = { src: "", w: 0, h: 0, pid: 0 };
                }

                if(typeof images.large[i] !== 'undefined'){
                    newItems[i].largeImage = {
                        src: images.large[i].src,
                        w: parseInt(images.large[i].width),
                        h: parseInt(images.large[i].height),
                        pid: parseInt(i),
                    };
                    
                    newItems[i].additional_page = images.large[i].additional_page;
                }else{
                    newItems[i].largeImage = { src: "", w: 0, h: 0, pid: 0 };
                }

                newItems[i].pins = items.extensions.pins[i] || [];
                newItems[i].inx = i;
            }

            return newItems;
        }
    }

    function _getData(url, callback) {
        $.ajax({
            url: url,
            type: "GET",
            dataType: 'json',
            success: callback,
            error: _errorCallback
        });
    }

    function _errorCallback(err) {
        console.log("ajax error: ", err);
    }

    function _getPageImgWidth(){
        // return window.innerWidth - _imgWrapMarginH;
        return document.querySelector(".vr-mobile-body__page-img-wrap img").clientWidth;
    }

    function _initSliderPages(data){
        _buildSliderData(data);

        _initialGenerateVerticalPages(0);
        _goToPageFromHash();


        fireEvent(document, 'view.gallery.inited', {});
    }

    function _removePageLoader(){
        $('.vr-mobile-body__page-img_loading').removeClass('vr-mobile-body__page-img_loading');
    }

    function _getPageWSizeRatio(pageInx, $page){
        var pageW,
            page;

        if($page.hasClass('vr-mobile-body__page-img-wrap_app-promo-page') && viewSettings.hasAppPromoPage){
            pageW = lastPagePromo.w;
        }else if($page.hasClass('vr-mobile-body__page-img-wrap_specific-promo-page') && viewSettings.hasSpecificPromoPage){
            pageW = specificPromoPage.w;
        }else if($page.hasClass('vr-mobile-body__page-img-wrap_related')){
            if(_jsonData.relatedBrochure.type === ViewConsts.xml){
                pageW = _jsonData.relatedBrochure.originalItems[0].w;
            }else{
                pageW = _jsonData.relatedBrochure.originalItems[0][_qualityKey].w;
            }
        }else{
            page = _jsonData.originalItems[pageInx];
            pageW = _jsonData.type == ViewConsts.xml ? page.w : page[_qualityKey].w;
        }

        return _getPageImgWidth() / pageW;
    }


    function _isPageRelatedThumb($page){
        return $page.hasClass('vr-mobile-body__page-img-wrap_related');
    }
    

    function _getPageHSizeRatio(pageInx, sizeRatio, $page){
        var pageH,
            page,
            jsonSource = _jsonData;

        if(_isPageRelatedThumb($page)){
            jsonSource = _jsonData.relatedBrochure;
        }

        if($page.hasClass('vr-mobile-body__page-img-wrap_app-promo-page') && viewSettings.hasAppPromoPage){
            pageH = lastPagePromo.h;
        }else if($page.hasClass('vr-mobile-body__page-img-wrap_specific-promo-page') && viewSettings.hasSpecificPromoPage){
            pageH = specificPromoPage.h;
        }else{
            page = jsonSource.originalItems[pageInx];
            pageH = jsonSource.type == ViewConsts.xml ? page.h : page[_qualityKey].h;
        }

        return sizeRatio * pageH;
    }

    function _loadPageByInx($page, pageInx, pageImgWidth, loadOnlyZones, onImgLoadCallback){
        var pageImgSrc = '',
            thumbSrc = '',
            // pageInx = $page.data('page-inx'),
            $pageImg,
            sizeRatio,
            pageH,
            loadOnlyZones = loadOnlyZones || false;
        
        sizeRatio = _getPageWSizeRatio(pageInx, $page);
        pageH = _getPageHSizeRatio(pageInx, sizeRatio, $page);

        if(typeof _jsonData.originalItems[pageInx] === 'undefined'){
            if($page.hasClass('vr-mobile-body__page-img-wrap_app-promo-page') && viewSettings.hasAppPromoPage){
                // sizeRatio = pageImgWidth / lastPagePromo.w;
                // pageH = sizeRatio * lastPagePromo.h;

                var pageAppHTML = lastPagePromo.html + (typeof lastPagePromo.map !== 'undefined' ? lastPagePromo.map.html : '');
                $page.html(pageAppHTML);
            }

            if($page.hasClass('vr-mobile-body__page-img-wrap_specific-promo-page') && viewSettings.hasSpecificPromoPage){
                // sizeRatio = pageImgWidth / specificPromoPage.w;
                // pageH = sizeRatio * specificPromoPage.h;

                var pagePromoHTML = '<img src="' + specificPromoPage.src + '" class="vr-mobile-body__page-img" usemap="#view-specific-promo">' +
                                    specificPromoPage.map.html;

                $page.html(pagePromoHTML);
            }
        }else{
            
            if(_jsonData.type === ViewConsts.xml && _jsonData.originalItems[pageInx].additional_page != true){
                var xmlPage = _jsonData.originalItems[pageInx];

                $page.html(xmlPage.html);
            }else{
                pageImgSrc = _jsonData.originalItems[pageInx][_qualityKey].src;
                thumbSrc = _jsonData.originalItems[pageInx][_thumbsKey].src;

                $pageImg = $page.find('.vr-mobile-body__page-img');
                
                if(pageInx > _imgsPerPageCnt){
                    $pageImg.attr('src', thumbSrc);
                }

                $pageImg.addClass(_imgBlazyClass);

                vrPinZones.createPinZonesForPage($page[0], pageInx, _qualityKey, pageImgWidth);

                if(loadOnlyZones === true){
                    vrPinZones.showZones($page.find('.slider-pin-zone, .product-pin-zone'));
                }else{
                    $pageImg[0].onload = function(){
                        vrPinZones.showZones($page.find('.slider-pin-zone, .product-pin-zone'));

                        if(typeof onImgLoadCallback === 'function'){
                            onImgLoadCallback();
                        }
                    };
                    
                    if($page.hasClass('vr-load-from-json') === true){
                        $pageImg.attr('src', pageImgSrc);
                        $pageImg.removeClass(_imgBlazyClass);
                        setTimeout(function(){
                            vrPinZones.resizePageZones($page, 1);
                        },1000);
                    }
                }
            }
            
            if(_preventPageHSet($page)){
                return;
            }

            $page.height(pageH);
        }

        
        $page.removeClass('vr-mobile-body__page-img_waiting');
    }

    function _initialShowZones($page, pageInx, pageImgWidth){
        vrPinZones.createPinZonesForPage($page[0], pageInx, _qualityKey, pageImgWidth);

        if(pageInx == 0){
            //vrPinZones.animateShow3($page.find('.slider-pin-zone, .product-pin-zone').get(), 0);
        }else{
            vrPinZones.showZones($page.find('.slider-pin-zone, .product-pin-zone'));
        }
    }
    
    
    /* Manages inital load of images, when html is printed from smarty. */
    function _initialGenerateVerticalPages(startInx){
        var $_pagesWaiting,
            eachCnt = 0;
        /* Load only first 10 images' zones. Otherwise load images or xml pages, (including app promo and specific promo pages) and zones for other pages. */
        if(_initialPagesLoaded === false){
            $_pagesWaiting = $('.vr-mobile-body__page-img-wrap:not(.vr-mobile-body__page-img_waiting)');

            $_pagesWaiting.each(function(inx, item){
                var $page = $(item),
                pageInx = $page.data('page-inx');
                
                if(typeof _jsonData.originalItems[pageInx] !== 'undefined' && typeof _jsonData.originalItems[pageInx].pins !== 'undefined' && $page.hasClass('vr-load-from-json') === false){
                    _initialShowZones($page, pageInx, _getPageImgWidth());
                }else{
                    _loadPageByInx($page, pageInx, _getPageImgWidth(), false);
                }
            });

            _initialPagesLoaded = true;

            return;
        }
        /* End load only first 10... */
        
        $_pagesWaiting = $('.vr-mobile-body__page-img_waiting');

        $_pagesWaiting.each(function(inx, item){
            if(eachCnt >= _imgsPerPageCnt){
                return false;
            }

            if(inx >= startInx + _imgsPerPageCnt){
                return false;
            }

            var $page = $(item),
                pageInx = $page.data('page-inx'),
                loadOnlyZones = false;
            
            if(startInx == 0 && $page.hasClass('vr-mobile-body__page-img_waiting') === false){
                loadOnlyZones = true;
            }

            _loadPageByInx($page, pageInx, _getPageImgWidth(), loadOnlyZones);

            eachCnt++;
        });

        $(_jsLoadMorePagesSel).attr('data-start-inx', (startInx + _imgsPerPageCnt));
        $(_jsLoadMorePagesSel).attr('data-imgs-per-page', _imgsPerPageCnt);
        _removePageLoader();
        
        setTimeout(function(){
            _reInitBlazy();
        }, 150);
    }

    function _preloadSlider() {
        var url = catalogDataUrl + brochureId;

        _getData(url, _initSliderPages);
    }

    function _initGalleryOnAjaxLoad(){
        document.addEventListener('built_slider_data', function(e) {
            // gallery.init();

            // fireEvent(document, 'view.gallery.inited', {});
        });
    }

    function _findFirstUnreadRelatedBrochure(jsonData){
        if(typeof _jsonData.relatedBrochures !== 'undefined' && _jsonData.relatedBrochures.length > 0){
            viewSettings.relatedBrochure = _jsonData.relatedBrochures[0];
        }

        $.each(jsonData.relatedBrochures, function(inx, item){
            if((typeof viewSettings.viewedBrochures !== 'undefined' && item.id in viewSettings.viewedBrochures == false) || (typeof viewSettings.viewedBrochures === 'undefined')){
                if(typeof item.skip_brochure !== 'undefined' && item.skip_brochure){
                    //Continue to next brochure as current is with outlink
                    //console.log('skipping rel because of skip_brochure');
                    return true;
                }

                viewSettings.relatedBrochure = item;
                return false; //break the loop
            }
        });
    }

    function _setNextBrochureMobile(){
        var $nxtBtn = $('.js-vr-next-brochure-btn');
        
        if(typeof viewSettings.relatedBrochure !== 'undefined' && !!viewSettings.relatedBrochure && viewSettings.relatedBrochure.brochure_link !== ''){
            $nxtBtn.attr('href', viewSettings.relatedBrochure.brochure_link);
        }else{
            $nxtBtn.hide();
        }
    }

    function _buildSliderData(data) {
        var options,
            galWrap = $('.vr-mobile-body'),
            promoLastPage,
            promoSpecificLastPage;

        _jsonData.relatedBrochures = false;

        if(typeof data.related_brochures !== 'undefined' && !!data.related_brochures && data.related_brochures.length > 0){
            _jsonData.relatedBrochures = data.related_brochures;

            _findFirstUnreadRelatedBrochure(_jsonData);
            _setNextBrochureMobile();
        }

        if (data.type === ViewConsts.xml) {
            mzView.cssFilters();
            var items = xmlSlides.getXmlData(data, false, false, false);
            items = xmlSlides.buildSingleContent(items.slice(), false, false, false, false, false);

            _jsonData.originalItems = items.slice();
            _jsonData.type = ViewConsts.xml;
        } else {
            images = _translateObjects(data);

            _jsonData.originalItems = images.slice();
        }

        _this.jsonData = _jsonData;
        vrPinZones = new VrPinZones(_jsonData);
        _this.vrPinZones = vrPinZones;
        vrPinZones.init();
    }

    function _isAdditionalPage(pageInx) {
        var isAddPage = typeof gal.jsonData.originalItems !== 'undefined' && typeof gal.jsonData.originalItems[pageInx] !== 'undefined' && gal.jsonData.originalItems[pageInx].additional_page;

        return isAddPage;
    }

    function _loadMorePages(startInx){

        var $loadMoreBtn = $(_jsLoadMorePagesSel);

        if(startInx < viewSettings.pagesLength){
            $(_pagesWrapSel).addClass('vr-mobile-body__page-img_loading');
            _initialGenerateVerticalPages(startInx);
        }else{
            $loadMoreBtn.hide();
        }

        if(startInx + _imgsPerPageCnt >= viewSettings.pagesLength){
            $loadMoreBtn.hide();
            _loadFirstPageFromNextBrochure();
        }
    }

    function _loadPagesBefore($page){
        var $prevPages = $page.prevAll('.vr-mobile-body__page-img_waiting');
            
        $prevPages.each(function(inx, prevPage){
            var prevPageInx = $(prevPage).data('page-inx');

            _loadPageByInx($(prevPage), prevPageInx, _getPageImgWidth());
        });
    }
    
    function _handleClicks(){
        $(document).on('click', _jsLoadMorePagesSel, function(e){
            e.preventDefault();
            e.stopPropagation();

            var $el = $(this),
                startInx = parseInt($el.attr('data-start-inx'));

            _loadMorePages(startInx);
        });


        $(document).on(isMobile ? 'touchstart' : 'click', _jsLastPageBtnSel, function(e){
            // e.preventDefault();
            e.stopPropagation();

            var $el = $(this),
                startInx = parseInt($(_jsLoadMorePagesSel).attr('data-start-inx')),
                pageInx = (viewSettings.pagesLength - 1);
                $page = $('#page-' + pageInx);
                    window.location.hash = $el[0].href;

            if($page.hasClass('vr-mobile-body__page-img_waiting') === true){
                _loadPagesBefore($page);
                _loadPageByInx($page, pageInx, _getPageImgWidth(), false, function(){
                    // window.location.hash = $el[0].href;
                });

                setTimeout(function(){
                    // window.location.hash = $el[0].href;
                }, 10);
            }else{
                // window.location.hash = $el[0].href;
            }

            _reInitBlazy();

            $(_jsLoadMorePagesSel).hide();
            _loadFirstPageFromNextBrochure();
        });

        $(document).on(isMobile ? 'touchstart' : 'click', '#navigation .vr-mobile-nav__btn', function(e){
            e.stopPropagation();
        });
        
    }

    function _handleScroll(){
        function _debouncedScrollPages() {
            var pagesHArr = [],
                _scrollEndTimeoutId = 0,
                pageImgWidth = _getPageImgWidth;

            $.each(jsonData.originalItems, function(inx, item) {
                var sizeRatio = pageImgWidth / item.largeImage.w;

                pagesHArr.push({ id: 'page-' + inx, h: item.largeImage.h * sizeRatio });
            });

            var _debouncedScroll = dom.debounce(function() {
                var oTop = 0;

                if (_scrollEndTimeoutId !== 0) {
                    clearTimeout(_scrollEndTimeoutId);
                }
                
                $.each(pagesHArr, function(inx, page){
                    var $page = $('#' + page.id);
                    
                    oTop = $page.offset().top - window.innerHeight;
                    $pinZones = $page.find('.slider-pin-zone, .product-pin-zone');

                    var pTop = $(window).scrollTop(),
                        hBuffer = page.h/4;

                    if (pTop - hBuffer > oTop){
                        $pinZones.addClass('pin-zone-animated');
                        // console.log('%c ' + page.id + ' shown', "color: green;");
                    }else{
                        // console.log(pTop + ' - ' + oTop);
                        // $pinZones.removeClass('pin-zone-animated');
                    }

                    _scrollEndTimeoutId = setTimeout(function() {
                        $pinZones.removeClass('pin-zone-animated');
                    }, _pinZoneAnimTime);
                });
            }, 50);

            // $(window).scroll(_debouncedScroll);
            return _debouncedScroll;
        }

        $(window).scroll(_debouncedScrollPages);
    }

    /*function _vrImgBlazyCallback(){
        vrPinZones.animateShow3($(_pagesWrapSel).find('.slider-pin-zone').get(), 0);
    }*/
    
    function _getPageInxFromHash(hash){
        return hash.substring(hash.indexOf('-') + 1)
    }
    
    function _goToPageFromHash(){
        if(window.location.hash !== ''
            && window.location.hash !== "#page-0" 
            && window.location.hash.indexOf('page') > -1
            && window.location.hash.lastIndexOf('#') == 0){

            var wHash = window.location.hash,
                $page,
                pageInx;

            if(wHash.indexOf('#page=') > -1){
                wHash = wHash.replace('=', '-');
            }

            $page = $(wHash);
            pageInx = $page.data('page-inx');
            
            if($page.length === 0 || $page[0].id == 'page-0'){
                return false;
            }

            _loadPagesBefore($page);

            /* Hide load more button if last page hash is accessed. */
            if(pageInx == viewSettings.pagesLength - 1){
                $(_jsLoadMorePagesSel).hide();
                
                setTimeout(function(){
                    _loadFirstPageFromNextBrochure();
                }, 50);
            }

            setTimeout(function(){
                _loadPageByInx($page, pageInx, _getPageImgWidth());
                _reInitBlazy();
                
                window.location.hash = '';
                window.location.hash = wHash;
            }, 10);
        }
    }

    function _preventPageHSet($page){
        //Skip page resize when page is xml and does not have background image.
        //returns true if page should NOT be resized;
        
        var preventResize = false,
            jsonSource = _jsonData;
        
        if(_isPageRelatedThumb($page)){
            jsonSource = _jsonData.relatedBrochure;
        }
        
        preventResize = jsonSource.type === ViewConsts.xml && $page.find('.xml-slide_fixed-height').length == 0;

        return preventResize;
    }

    function _resizePages(){
        var $pages = $('.vr-mobile-body__page-img-wrap:not(.vr-mobile-body__page-img_waiting)');
        
        $pages.each(function(inx, page){
            var $page = $(page),
                pageH,
                sizeRatio,
                pageInx = $page.data('page-inx');

            if(_preventPageHSet($page)){
                return;
            }

            sizeRatio = _getPageWSizeRatio(pageInx, $page);
            pageH = _getPageHSizeRatio(pageInx, sizeRatio, $page);
            
            $page.height(pageH);
        });
    }

    function _onOrientationChange(){
        //_resizePages();
        vrPinZones.onOrientationChange();
    }

    function _handleOrientationChange(){
        var onOrientationChangeDebounced = dom.debounce(_onOrientationChange, 150);

        window.addEventListener('orientationchange', onOrientationChangeDebounced);
    }

    function _handleWindowResize(){
        var handleEventDebounced = dom.debounce(_onOrientationChange, 300);

        window.addEventListener('resize', handleEventDebounced);
    }

    function _reInitBlazy(){
        // return;
        bLazy.destroy();
        bLazy = new Blazy(bLazySettings);
    }

    function _loadFirstPageFromNextBrochure(){
        // viewSettings.relatedBrochure.id = "62340";
        if (_relatedBrochureLoaded == false && typeof viewSettings.relatedBrochure !== 'undefined' && typeof viewSettings.relatedBrochure.id !== 'undefined') {
            _getData(catalogDataUrl + viewSettings.relatedBrochure.id, function(relatedData) {
                if(typeof relatedData !== 'undefined'){
                    var items;

                    _jsonData.relatedBrochure = {
                        id: viewSettings.relatedBrochure.id,
                        mode: relatedData.mode,
                        originalItems: [],
                        type: ''
                    };

                    if(relatedData.type === ViewConsts.xml){
                        items = xmlSlides.getXmlData(relatedData, false, false, false);

                        _jsonData.relatedBrochure.type = relatedData.type;
                        _jsonData.relatedBrochure.originalItems = xmlSlides.buildSingleContent(items.slice(), false, false, false, false, false);
                    }else{

                        items = _translateObjects(relatedData);

                        if(typeof items === 'undefined'){
                            console.error('WARNING: JSON data is not complete. "images" property is missing.');
                            return;
                        }

                        _jsonData.relatedBrochure.originalItems = items.slice();
                    }

                    _renderNextBrochure(_jsonData.relatedBrochure, viewSettings.relatedBrochure.brochure_link);
                }
            });
        }
    }

    function _renderNextBrochure(relatedData, nextUrl){
        var pageH = 0,
            pageW = 0,
            relWrap = document.createElement('a'),
            nextBtnHtml = '<div class="vr-mobile-body__page-next-overlay abs-centered">' + 
                                '<button class="vr-btn vr-btn_blue vr-btn_big-txt vr-btn_next-rel abs-centered">' + viewLang.view_next_brochure + 
                                '<svg width="20px" height="20px" enable-background="new 0 0 451.846 451.847" version="1.1" viewBox="0 0 451.846 451.847" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m345.44 248.29-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373z" fill="#fff"></path></g></svg>' +
                                '</button>' +
                            '</div>';

        relWrap.className = 'vr-mobile-body__page-img-wrap vr-mobile-body__page-img-wrap_related';
        relWrap.href = nextUrl;
        relWrap.setAttribute('data-page-inx', 0);
        relWrap.onclick = function(){
            ga('send', 'event', 'brochure-view-' + (isMobile ? 'mobile' : 'desktop'), 'next-brochure-button-cover', nextUrl);
        };

        if(relatedData.type == ViewConsts.xml){
            relWrap.innerHTML = nextBtnHtml;

            var relXmlSlide = document.createElement('div');
            relXmlSlide.className = 'xml-slide html-slide';

            relXmlSlide.appendChild(relatedData.originalItems[0].html);
            relWrap.appendChild(relXmlSlide);

            pageW = relatedData.originalItems[0].w;
            pageH = relatedData.originalItems[0].h;
        }else{
            var mediumImg = relatedData.originalItems[0].mediumImage;
            pageH = 0;

            relWrap.innerHTML = '<img class="vr-mobile-body__page-img" src="' + mediumImg.src + '" alt="" />' +
                                nextBtnHtml;

            pageW = mediumImg.w;
            pageH = mediumImg.h;
        }

        if(document.querySelectorAll('.vr-mobile-body__wrap').length > 0){
            //this is for view V3
            var relBottom = document.querySelector('.vr-related-bottom');
            document.querySelector('.vr-mobile-body__wrap').appendChild(relWrap);
            relBottom.parentNode.insertBefore(relWrap, relBottom);
        }else{
            $('#main').append(relWrap);
        }

        pageH = (_getPageImgWidth() / pageW) * pageH;

        $('.vr-mobile-body__page-img-wrap_related').width(_getPageImgWidth());

        _relatedBrochureLoaded = true;
    }

    function _loadNextRelBroOn(e){
        if(typeof viewSettings.relatedBrochure === 'undefined'){
            return;
        }

        var $_pagesWaiting = $('.vr-mobile-body__page-img-wrap:not(.vr-mobile-body__page-img_waiting)');

        if($_pagesWaiting.length <= viewSettings.pagesLength && $_pagesWaiting.length <= _imgsPerPageCnt){
            if(!$(".vr-mobile-body__page-img-wrap_related").length) {
                _loadFirstPageFromNextBrochure();
            }
        }

        if(typeof site_no !== 'undefined' && site_no === true && typeof isMobile !== 'undefined' && isMobile){
            $('.mobile-device .vr-related-bottom .vr-related-bottom__btn a').click();
        }

        if(isMobile){
            $(document).off('touchstart', 'body', _loadNextRelBroOn);
        }else{
            $(document).off('scroll', _loadNextRelBroOn);
        }
    }

    function _handleLoadNextRelBro(){
        if(isMobile){
            $(document).on('touchstart', 'body', _loadNextRelBroOn);
        }else{
            $(document).on('scroll', _loadNextRelBroOn);
        }
    }

    function _zoomIcons() {
        var scrollDistance = { x: 0, y: 0 };
        
        $(document).on('click', ".zoomin_icon", function(){
            var pageIdToZoom = "#" + $(this).closest(".page_counter").attr("data-page-id");
            scrollDistance.x = document.querySelector(pageIdToZoom).offsetWidth/2;
            scrollDistance.y = document.querySelector(pageIdToZoom).offsetHeight/2;

            // if($(pageIdToZoom).hasClass("zoom-level-two")) {
            //     $(pageIdToZoom).removeClass("zoom-level-two")
            // } else if ($(pageIdToZoom).hasClass("zoom-level-one")){
            //     $(pageIdToZoom).removeClass("zoom-level-one")
            //     $(pageIdToZoom).addClass("zoom-level-two");
            // } else {
            //     $(pageIdToZoom).addClass("zoom-level-one");
            // }
            if ($(pageIdToZoom).hasClass("zoomin-one")){
                $(pageIdToZoom).removeClass("zoomin-one")
                $(pageIdToZoom).addClass("zoomin-two");
                $(this).hide();
                $(".zoomout_icon").show();
                vrPinZones.resizePageZones(pageIdToZoom, 3);
                $(pageIdToZoom).scrollTop(scrollDistance.y * 2);
                $(pageIdToZoom).scrollLeft(scrollDistance.x * 2);
            } else {
                $(pageIdToZoom).addClass("zoomin-one");
                vrPinZones.resizePageZones(pageIdToZoom, 2);
                $(pageIdToZoom).scrollTop(scrollDistance.y);
                $(pageIdToZoom).scrollLeft(scrollDistance.x);
            }

            ga('send', 'event', { eventCategory: 'brochure-view-desktop', eventAction: 'Zoom', eventLabel: "plus"});
        });

        $(document).on('click', ".zoomout_icon", function(){
            var pageIdToZoom = "#" + $(this).closest(".page_counter").attr("data-page-id");

            if($(pageIdToZoom).hasClass("zoomin-two")) {
                $(pageIdToZoom).removeClass("zoomin-two");
                $(pageIdToZoom).addClass("zoomout-one");
                vrPinZones.resizePageZones(pageIdToZoom, 2);
                $(pageIdToZoom).scrollTop(scrollDistance.y);
                $(pageIdToZoom).scrollLeft(scrollDistance.x);
            } else {
                $(pageIdToZoom).removeClass("zoomout-one");
                $(this).hide();
                $(".zoomin_icon").show();
                vrPinZones.resizePageZones(pageIdToZoom, 1);
            }

            ga('send', 'event', { eventCategory: 'brochure-view-desktop', eventAction: 'Zoom', eventLabel: "minus"});
        });
    }

    function checkPageVisibility(){

        // missing forEach on NodeList for IE11
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        function debounce(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };

        var pages = document.querySelectorAll("div[id^='page-']");
        var relatedBottomBrochures = document.querySelector(".vr-related-bottom");
        var pageCounter = document.querySelector(".page_counter");

        function checkPage() {
            var relatedBottomBrochuresFromTop = relatedBottomBrochures.offsetTop;
            var scrollToRelatedBottom = window.pageYOffset + window.innerHeight;
            var viewRightNav = document.querySelector(".view_navigation");
            var previousPage = pageCounter.dataset.pageId;

            //pages.forEach(function(page) {
            $.each(pages, function(i, page) {
                // half way through the image
                var scrollInPage = (window.pageYOffset + window.innerHeight) - page.offsetHeight / 2;
                // bottom of the image
                var imageBottom = page.offsetTop + page.offsetHeight;
                var isHalfShown = scrollInPage > page.offsetTop;
                var isNotScrolledPast = window.pageYOffset < imageBottom;

                if (isHalfShown && isNotScrolledPast) {
                    pageNumber = (page.id).split("-").pop();
                    //document.querySelector(".view_navigation .prev-page").href = "#page-" + (parseInt(pageNumber)-1);
                    //document.querySelector(".view_navigation .next-page").href = "#page-" + (parseInt(pageNumber)+1);
                    document.querySelector(".page_counter-current").innerText = pageNumber < 9 ? "0" + (parseInt(pageNumber)+1) : (parseInt(pageNumber)+1);
                    pageCounter.setAttribute("data-page-id", page.id);
                }
            });
            
            if (relatedBottomBrochuresFromTop > scrollToRelatedBottom) {
                viewRightNav.classList.remove('hide');
                pageCounter.classList.remove('hide');
            } else {
                viewRightNav.classList.add('hide');
                pageCounter.classList.add('hide');
            }

            if(previousPage !== pageCounter.dataset.pageId) {
                if($("#"+previousPage).hasClass("zoomin-one") || $("#"+previousPage).hasClass("zoomin-two") || $("#"+previousPage).hasClass("zoomout-one")) {
                    $("#"+previousPage).removeClass("zoomin-one zoomin-two zoomout-one");
                    $(".zoomin_icon").show();
                    $(".zoomout_icon").hide();
                    $("#"+previousPage).scrollTop(0);
                    $("#"+previousPage).scrollLeft(0);
                    vrPinZones.resizePageZones("#"+previousPage, 1);
                }
            }
        }
        checkPage();
        window.addEventListener('scroll', debounce(checkPage, 10, true));
    }

    function _init(){
        _preloadSlider();
        _initGalleryOnAjaxLoad();
        _handleClicks();
        _handleOrientationChange();
        _handleLoadNextRelBro();
        _handleWindowResize();
        // _handleScroll();
        _zoomIcons();
        if(!isMobile && $(".view_navigation").length) {
            checkPageVisibility();
        }
    }

    _this.init = _init;
    _this.getPageImgWidth = _getPageImgWidth;
    _this.initialGenerateVerticalPages = _initialGenerateVerticalPages;
    _this.goToPageFromHash = _goToPageFromHash;
    _this.onOrientationChange = _onOrientationChange;
    _this.isAdditionalPage = _isAdditionalPage;
};